var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24.6296C0 11.0271 11.0271 0 24.6296 0C38.2322 0 49.2592 11.0271 49.2592 24.6296C49.2592 38.2322 38.2322 49.2592 24.6296 49.2592C11.0271 49.2592 0 38.2322 0 24.6296Z",
    fill: "#0C94FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.8971 15.3529C34.1957 15.2272 34.5225 15.1839 34.8436 15.2273C35.1646 15.2708 35.4681 15.3996 35.7225 15.6002C35.9769 15.8008 36.1729 16.0659 36.2901 16.368C36.4072 16.67 36.4413 16.9979 36.3887 17.3176L33.6482 33.9407C33.3824 35.5441 31.623 36.4637 30.1525 35.665C28.9224 34.9967 27.0954 33.9672 25.4521 32.893C24.6304 32.3553 22.1134 30.6335 22.4228 29.4082C22.6886 28.3606 26.9178 24.4238 29.3344 22.0833C30.283 21.1637 29.8504 20.6333 28.7303 21.4791C25.9487 23.5792 21.4827 26.7728 20.0061 27.6718C18.7035 28.4645 18.0244 28.5998 17.2124 28.4645C15.731 28.218 14.3572 27.8362 13.2358 27.371C11.7206 26.7426 11.7943 24.6595 13.2346 24.0529L33.8971 15.3529Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.6fd86502a5555f1abf17f78b5b118f56.svg";
export { ForwardRef as ReactComponent };